import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { G_HOOK__output__field_hovered_set } from '../_base/_hooks/G_HOOK__output__field_hovered_set';
import { G_UI_FIELD__header } from '../_base/G_UI_FIELD__header';
import { G_BUTTON_GRID2D_MODE__use_as_both_dimensions } from './G_BUTTON_GRID2D_MODE__use_as_both_dimensions';

interface PROPS {
  field: FIELD__base;
}
export function G_UI_GRID2D_MODE__both_dimensions({ field }: PROPS) {
  let { onMouseOver, onMouseLeave } = G_HOOK__output__field_hovered_set({ field });

  return (
    <div {...{ onMouseOver, onMouseLeave }} className="w-full h-5">
      <G_UI_FIELD__header {...{ field }} hide_buttons_grid2d_dimension>
        <G_BUTTON_GRID2D_MODE__use_as_both_dimensions {...{ field }} />
      </G_UI_FIELD__header>
    </div>
  );
}
